import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { Locations } from "../locations";
import { LocationsService } from "../locations.service";
import { LocationCollection } from "../../location-collections/location-collections";
import { LocationCollectionsService } from "../../location-collections/location-collections.service";

@Component({
    selector: 'app-locations',
    templateUrl: './list.component.html',
    styleUrls: [
        './list.component.scss'
    ],
    standalone: false
})
export class LocationsViewComponent implements OnInit {
  locationCollection: LocationCollection;
  locations: Locations[];
  selectedLocation: Locations;
  loading = false;
  isEditing = false;
  tableConfig = {
    columns: {
      name: {
        title: 'Location Name'
      },
      full_address: {
        title: 'Location Address'
      },       
      created_at: {
        title: 'Created On',
      }
    },
    
    actions: {
      add: false,
      edit: false,
      delete: false
    }
  };

  titles = Object.keys(this.tableConfig.columns).map(key => this.tableConfig.columns[key].title);
  keys = Object.keys(this.tableConfig.columns)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private locationsService: LocationsService,
    private locationCollectionsService: LocationCollectionsService
  ) {  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if(!this.locations) {
        this.locations = this.locationsService.formatData(data.locations);
        this.locationCollection = data.locationCollection.location_collection;
      }
    });
  }

  public addLocation(event) {
    this.router.navigate(['/location-collections', this.locationCollection.id, 'add-location']);
  }

  public onRowSelect(event) {
    this.router.navigate(['/location-collections', this.locationCollection.id, 'locations', event.data.id]);
  }

  public editLocationCollection() {
    this.router.navigate(['/locationCollections', this.locationCollection.id]);
  }

  public deleteLocationCollection() {
    this.locationCollectionsService.delete(this.locationCollection.id).subscribe(() => {
      this.router.navigate(['/locations']);
    });
  }
}